import type { BusinessInfo, BusinessPort } from './ports.ts';
import type { WorkerClient } from './worker.ts';

export function createBusiness(worker: WorkerClient): BusinessPort {
  return {
    get: shopId => worker.call<BusinessInfo>('get_business_info', { shopId }),
    save: async (shopId, patch) => { await worker.call('save_business_info', { shopId, ...patch }); },
    contact: shopId => worker.call('get_business_contact', { shopId }),
  };
}
